import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { OrganisationListComponent } from './organisation-list/organisation-list.component'

export const organisationRoutes: Route[] = [
  {
    path: 'organisations',
    component: OrganisationListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'organisations/:id/edit',
    redirectTo: 'organisations/:id',
    pathMatch: 'full'
  },
  {
    path: 'organisations/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Organisation',
        nameSingular: 'Organisation',
        namePlural: 'Organisations',
        path: 'organisations',
        slug: 'taxonomies/organisations',
        title: 'Organisations'
      }),
      permission: 'readTaxonomies'
    }
  }
]
